import type { Bcp47Locale } from '@backmarket/http-api/src/standards/Locale.ts'
import { getLanguageFromLocale } from '@backmarket/nuxt-module-i18n/getLanguageFromLocale'

/**
 * A review is translatable when it has a comment written in a language
 * different from the current locale's language (regions are ignored, so
 * `fr-be` and `fr-fr` share the same language).
 */
export function isReviewTranslatable(
  review: { comment?: string; languageCode?: string },
  locale: Bcp47Locale,
): boolean {
  const currentLanguage = getLanguageFromLocale(locale).toLowerCase()
  const reviewLanguage = (review.languageCode || '').toLowerCase()

  return (
    !!review.comment && !!reviewLanguage && reviewLanguage !== currentLanguage
  )
}
